import React from "react";

import { Button } from "antd";
import api from "../../../services/api";

export default class RelatorioSinistroAssociado extends React.Component {
  state = {
    gerando: false
  };

  handleOnClick = async () => {
    this.setState({
      gerando: true
    });
    const rel = await api("/relatorio-sinistro-associado/");
    window.open(
      "http://api.debt.com.br/media/relatorios/saida/rel_sinistro_associado.xlsx"
    );
    this.setState({
      gerando: false
    });
  };
  render() {
    return (
      <div>
        <Button onClick={this.handleOnClick}>
          {this.state.gerando ? "Gerando relatório" : "Gerar"}
        </Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Relatorios/RelatorioSinistroAssociado/index.js